import {
  ALLOWLIST_CONTEXTUAL_SEGMENTS_V3,
  ENABLED_CONTEXTUAL_SEGMENTS_V3,
} from '@openx/constants/feature-flag-keys.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';

/**
 * Feature flag for Contextual Segments versioning.
 *
 * Current behavior:
 * - `false`: contextual segments are a section of the Custom Targeting card (V2 in OA, V1 in DSP/publisher)
 * - `true`: contextual segments get their own card (V3 in OA, V1 in DSP/publisher)
 *
 * The flag is controlled via GrowthBook: `contextual-segments-v3` (boolean, on for everyone)
 * OR `allowlist-contextual-segments-v3` (hashed emails allowlist).
 */
export const useStandaloneContextualSegmentsEnabled = (): boolean => {
  const { isGrowthbookFeatureOn } = usePermissionContext();
  return (
    isGrowthbookFeatureOn(ENABLED_CONTEXTUAL_SEGMENTS_V3) || isGrowthbookFeatureOn(ALLOWLIST_CONTEXTUAL_SEGMENTS_V3)
  );
};
